import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Index from './components/Index';
import Prestamos from './components/Prestamos';
import Abonos from './components/Abonos';
import Navbar from './components/Navbar';
import DeudasPorChofer from './components/DeudasPorChofer';



const App = () => {
  return (
    <Router>
      <Navbar />


      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/prestamos" element={<Prestamos />} />
        <Route path="/abonos" element={<Abonos />} />
        <Route path="/deudas/:chofer_id" element={<DeudasPorChofer />} />

      </Routes>
    </Router>
  );
};

export default App;
